<template>
  <v-row
    v-for="(row, rowIndex) in metricRows"
    :key="rowIndex"
    class="mb-5 align-items-center justify-center">
    <v-col
      v-for="(metric, index) in row"
      :key="index"
      cols="12"
      md="4">
      <v-card>
        <v-card-text>
          <MetricCardDisplay
            v-bind="metric"
            variant="extensive" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { TotalMetricsProps } from '@/models/metricDefinitions';
import { groupBySizes } from '@/utils/grouping';
import MetricCardDisplay from './metrics/MetricCardDisplay.vue';

interface Props extends TotalMetricsProps {
  rowSizes?: number[];
}

const { metrics, rowSizes } = defineProps<Props>();

const metricRows = computed(() => groupBySizes(metrics, rowSizes));
</script>
